import { get, writable } from "svelte/store"
import { updateHtmlClass } from "@utils/directives/useCSSObserver"

export const readerFocusMode = writable(false)

readerFocusMode.subscribe((focused) => updateHtmlClass("reader-focus", focused))

export function enterReaderFocus() {
    readerFocusMode.set(true)
}

export function exitReaderFocus() {
    readerFocusMode.set(false)
}

export function toggleReaderFocus() {
    readerFocusMode.update((focused) => !focused)
}

export function isReaderFocused() {
    return get(readerFocusMode)
}
